Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "ToggleSwitch805853830",
  {"root":"ToggleSwitch805853830--root","input":"ToggleSwitch805853830--input","track":"ToggleSwitch805853830--track","knob":"ToggleSwitch805853830--knob","knobIcon":"ToggleSwitch805853830--knobIcon"},
  ".ToggleSwitch805853830--root{display:inline-flex;position:relative}.ToggleSwitch805853830--input{position:absolute;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;padding:0;cursor:inherit}",
  1,
  "ToggleSwitch805853830"
);
__webpack_require__.stylable.$.register(exports.default)
